import React, {useEffect, useState} from 'react';
import {Box} from '@mui/material';
import {Outlet, useLocation} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {getRouteMatchPath} from '../../../utility/routeUtil';
import routes from '../../../routes/routes';
import {resetTableState} from '../../../store/tableSlice';

const RequestAndResponsesTab = () => {
    const dispatch = useDispatch();
    const {pathname} = useLocation();
    const path = getRouteMatchPath(routes, pathname);
    const [formsState, setFormsState] = useState(null);

    useEffect(() => {
        return () => {
            dispatch(resetTableState(path));
            dispatch(resetTableState(`${path}/general`));
        };
    }, [dispatch]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minHeight: '100%',
                paddingTop: 2,
            }}
        >
            <Outlet context={{key: path, formsState, setFormsState}}/>
        </Box>
    );
};

export default RequestAndResponsesTab;